import {LockerIcon, PickupPointsIcon, RussianPostIcon, SortCenterIcon} from '@yandex-delivery/blocks'

import {isTerminal} from '../utils/is-terminal'
import {isWarehouse} from '../utils/is-warehouse'
import type {Props} from './types'

export function PointIcon(props: Props) {
  const {point, className} = props

  if (point?.is_post_office) {
    return <RussianPostIcon className={className} />
  }

  if (isTerminal(point?.type)) {
    return <LockerIcon className={className} />
  }

  if (isWarehouse(point?.type)) {
    return <SortCenterIcon className={className} />
  }

  return <PickupPointsIcon className={className} />
}
